import React from "react";
import Layout from "../../Layout";
import ProfileContainer from "../../containers/Profile";

export default function Profile() {
  return (
    <Layout className="bg-gray-50">
      <ProfileContainer />
    </Layout>
  );
}
